var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownFigma({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82022 5.8991C4.88038 5.91168 4.93883 5.93313 4.99999 5.93313C5.06115 5.93313 5.11959 5.91168 5.17976 5.8991C5.23055 5.88849 5.28283 5.88849 5.33142 5.86877C5.39011 5.84509 5.43918 5.79996 5.49244 5.76323C5.53511 5.73388 5.58332 5.71637 5.62142 5.67864C5.62265 5.67741 5.62289 5.67568 5.62413 5.67445C5.62538 5.67322 5.62709 5.67298 5.62832 5.67174L9.74452 1.50523C10.0878 1.15802 10.0848 0.598743 9.73761 0.255484C9.3904 -0.087775 8.83013 -0.0848155 8.48786 0.262393L5 3.79292L1.51213 0.262393C1.16985 -0.0848155 0.609593 -0.087775 0.262385 0.255484C0.0877962 0.428104 9.63269e-07 0.655953 9.63269e-07 0.883813C9.63269e-07 1.10772 0.0848255 1.33262 0.255475 1.50523L4.37168 5.67174C4.37291 5.67297 4.37464 5.67321 4.37587 5.67445C4.3771 5.67569 4.37734 5.67741 4.37859 5.67864C4.41669 5.71637 4.4649 5.73388 4.50756 5.76323C4.56082 5.79997 4.6099 5.84509 4.66858 5.86877C4.71717 5.88849 4.76941 5.88849 4.82022 5.8991Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownFigma);
export default __webpack_public_path__ + "static/media/chevron-down-figma.5fe59b3c39f60e0b5b08fd30ea43143c.svg";
export { ForwardRef as ReactComponent };